/* eslint-disable */
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { http, type Meta } from "~/foundation/Api";
import { BookmarkModel } from "~/project/AramcoLife/generated-types";
import { BookmarkCreateRequestModel } from "~/project/AramcoLife/generated-types";

export const bookmarkServiceMeta: Meta<typeof bookmarkService> = {
	getAll: ["GET", "/api/v1/bookmark/"],
	get: ["GET", "/api/v1/bookmark/:bookmarkId"],
	create: ["POST", "/api/v1/bookmark/"],
	delete: ["DELETE", "/api/v1/bookmark/:pageItemId"],
};

// Project.AramcoLife.Controllers.Api.ApiV1BookmarkController
export const bookmarkService = {
	async getAll() {
		return await http.fetch<BookmarkModel[], undefined>(bookmarkServiceMeta.getAll, {  });
	},
	async get(bookmarkId: /* Guid */ string) {
		return await http.fetch<BookmarkModel, undefined>(bookmarkServiceMeta.get, { params: { bookmarkId } });
	},
	async create(body: BookmarkCreateRequestModel) {
		return await http.fetch<undefined, BookmarkCreateRequestModel>(bookmarkServiceMeta.create, { body });
	},
	async delete(pageItemId: /* Guid */ string) {
		return await http.fetch<undefined, undefined>(bookmarkServiceMeta.delete, { params: { pageItemId } });
	},
};
